export default __webpack_public_path__ + "static/media/logo.cee402fc.png";